<div class="product-wrapper">
  <div class="product-image">
    <img [src]="getProductImage()" alt="">
  </div>
  <div class="info">
    <div class="name">{{product.product_name}}</div>
    <div class="price">{{product.price_points}} Punkte</div>
  </div>
</div>
